import * as React from 'react'

import { type Item } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import i18n from 'modules/core/lib/i18n'

import { useAttendanceFeatures } from 'modules/attendance/lib/attendanceFeaturesContext'
import type { ProjectTimeRecord } from 'modules/project_management/hooks/projectTimeRecord/useGetProjectTimeRecords'
import type { ProjectWorkers } from 'modules/project_management/hooks/projectWorker/useGetProjectsAssignedToWorker'

import AssignSubprojectToShiftForm from './AssignSubprojectToShiftForm'
import { IProjectValues, IShiftWithProjectValuesHandler } from './types'

interface AddProjectTimeRecordProps {
  projectsAssigned: ProjectWorkers
  shiftWithProjectTimeRecord: ProjectTimeRecord | null
  shiftWithProjectValues: IProjectValues
  shiftWithProjectValuesHandler: ({
    shiftId,
    projectWorkerId,
    subprojectId,
  }: IShiftWithProjectValuesHandler) => void
}

const AssignProjectToShiftForm = ({
  projectsAssigned,
  shiftWithProjectTimeRecord,
  shiftWithProjectValues,
  shiftWithProjectValuesHandler,
}: AddProjectTimeRecordProps) => {
  const [name, setName] = React.useState<string>(
    shiftWithProjectTimeRecord?.projectWorker?.imputableProject?.name ?? ''
  )

  const [subprojects, setSubprojects] = React.useState(
    shiftWithProjectTimeRecord?.projectWorker?.imputableProject?.subprojects ?? []
  )

  const onSelectProject = ({ label: name, value }: Item) => {
    setName(name)

    const projectWorkerSelected = projectsAssigned.find(
      (projectWorker) => projectWorker.id == value
    )

    setSubprojects(projectWorkerSelected?.imputableProject?.subprojects ?? [])

    shiftWithProjectValuesHandler({
      shiftId: shiftWithProjectValues.shiftId,
      projectWorkerId: Number(value),
    })
  }

  const onSelectEmpty = () => {
    setName('')
    setSubprojects([])

    shiftWithProjectValuesHandler({
      shiftId: shiftWithProjectValues.shiftId,
      projectWorkerId: undefined,
    })
  }

  // DropdownSearchBar list of projects assiged to the employee
  const employeeProjects: Item[] = projectsAssigned.map((projectAssigned) => ({
    label: projectAssigned.imputableProject?.name || '',
    value: projectAssigned.id || '',
  }))

  const { featureAvailability: hasSubprojectsFeature } = useAttendanceFeatures(
    Features.projects_with_subprojects
  )
  const hasSubprojectsToTrack = subprojects.length > 0
  const showSubprojects = hasSubprojectsFeature && hasSubprojectsToTrack

  return (
    <>
      <DropdownSearchBar
        name={name || i18n.t('common.select')}
        label={i18n.t('clock_in.projects.modal.project_field_title')}
        onSelectEmpty={onSelectEmpty}
        onSelect={onSelectProject}
        labelNotFound={i18n.t('common.projects_not_found')}
        data={employeeProjects}
        searchLabel={i18n.t('common.search')}
        sortLabel={i18n.t('common.name')}
        selectLabel={i18n.t('common.select')}
      />
      {showSubprojects && (
        <AssignSubprojectToShiftForm
          key={`subproject-${shiftWithProjectValues.shiftId}`}
          subprojects={subprojects}
          shiftWithProjectTimeRecord={shiftWithProjectTimeRecord}
          shiftWithProjectValues={shiftWithProjectValues}
          shiftWithProjectValuesHandler={shiftWithProjectValuesHandler}
        />
      )}
    </>
  )
}

export default AssignProjectToShiftForm
